import { ApplicationConfig, inject } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';

import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { OepaAuthProfile, OepaIopAuthLibService } from '@ohioepa/oepa-iop-auth-lib';
import { OAuthService, provideOAuthClient } from 'angular-oauth2-oidc';
import { environment } from '../environments/environment';
// import { OepaHttpInterceptor } from '@ohioepa/oepa-common-lib';
import { AccountSearchService, AccountService, EdocAttachmentService, EntityService, LynxService, OepaAddressService,
         OepaHttpInterceptor, OepaPinService, OepaReferenceService, OepaUserAccountService, ParameterService, ParamsHelpService,
         ShoppingCartService, TableExportService } from '@ohioepa/oepa-ui-lib';
import { OepaFileUtilService } from '@ohioepa/oepa-common-lib';

const profile: OepaAuthProfile = {
  clientId: environment.clientID,
  redirectUri: environment.redirectURI
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(), 
    provideToastr({ 
      positionClass: 'toast-bottom-full-width', 
      disableTimeOut: true, 
      closeButton: true
    }),
    provideOAuthClient(),
    { provide: HTTP_INTERCEPTORS, useClass: OepaHttpInterceptor, multi: true},
    {
      provide: OepaIopAuthLibService,
      useFactory: () => {
        return new OepaIopAuthLibService(inject(OAuthService), profile)
      }
    },
    { provide: AccountSearchService, useFactory: () => { return new AccountSearchService(inject(HttpClient), environment.ebizRootURL, 'ASBESTOS')} },
    { provide: AccountService, useFactory: () => { return new AccountService(inject(HttpClient), environment.ebizRootURL, 'ASBESTOS')} },
    { provide: EdocAttachmentService, useFactory: () => { return new EdocAttachmentService(inject(HttpClient), environment.ebizRootURL, 'ASBESTOS')} },
    { provide: EntityService, useFactory: () => { return new EntityService(inject(HttpClient), environment.ebizRootURL, 'ASBESTOS')} },
    { provide: LynxService, useFactory: () => { return new LynxService(inject(HttpClient), environment.ebizRootURL, 'ASBESTOS')} },
    { provide: OepaAddressService, useFactory: () => { return new OepaAddressService(inject(HttpClient), environment.ebizRootURL, 'ASBESTOS')} },
    { provide: OepaFileUtilService, useFactory: () => { return new OepaFileUtilService(inject(HttpClient), environment.ebizRootURL, 'ASBESTOS')} },
    { provide: OepaPinService, useFactory: () => { return new OepaPinService(inject(HttpClient), environment.ebizRootURL, 'ASBESTOS')} },
    { provide: OepaReferenceService, useFactory: () => { return new OepaReferenceService(inject(HttpClient), environment.ebizRootURL, 'ASBESTOS')} },
    { provide: OepaUserAccountService, useFactory: () => { return new OepaUserAccountService(inject(HttpClient), environment.ebizRootURL, 'ASBESTOS')} },
    { provide: ParameterService, useFactory: () => { return new ParameterService(inject(HttpClient), environment.ebizRootURL, 'ASBESTOS')} },
    { provide: ParamsHelpService, useFactory: () => { return new ParamsHelpService(inject(HttpClient), environment.ebizRootURL, 'ASBESTOS')} },
    { provide: ShoppingCartService, useFactory: () => { return new ShoppingCartService(inject(HttpClient), environment.ebizRootURL, 'ASBESTOS')} },
    { provide: TableExportService, useFactory: () => { return new TableExportService(inject(HttpClient), environment.ebizRootURL, 'ASBESTOS')} },
  ]
};